
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class CadastroFuncionarioService {

  constructor(private http:HttpService) { }

  saveCadastrarUsuario(data: any, successHandle: Function, errorHandle:Function) {
    return this.http.doPost('/employee', data, successHandle, errorHandle);
  }

  updateCadastrarUsuario(data: any, successHandle: Function, errorHandle: Function) {
    return this.http.doPut('/employee', data, successHandle, errorHandle);
  }

  pesquisarUsuario(path:any, data: any, successHandle:Function, errorHandle:Function) {

    return this.http.doGet('/integrated/employee/'+path, data, successHandle, errorHandle);
  }

  pesquisaPessoaCpf(path:any, data: any, successHandle:Function, errorHandle:Function) {
    return this.http.doGet('/employee/'+path, data, successHandle, errorHandle);
  }

  validateRegistration(data: any, successHandle:Function, errorHandle:Function) {

    return this.http.doGet('/employee/validateRegistration', data, successHandle, errorHandle);
  }

  address(path:any, data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/person/address/'+path, data, successHandle, errorHandle);

  }


  validateEmail(data: any, successHandle: Function, errorHandle: Function) {
    return this.http.doGet(`/plans/user/${data.cpf}/${data.email}`, null, successHandle, errorHandle);
  }

}